import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { DatePipe, NgIf, NgStyle } from '@angular/common';
import { IArticleOverview } from "../../../services/models/articles.model";

@Component({
  selector: 'app-article-item',
  standalone: true,
  templateUrl: './article-item.component.html',
  imports: [
    NgStyle,
    DatePipe,
    NgIf
  ],
  styleUrls: ['./article-item.component.scss']
})
export class ArticleItemComponent implements OnInit {
  // Inputs
  @Input() Article: IArticleOverview | null = null;
  @Input() Class: string | null = null;

  protected imageUrl: string = '';
  protected hasImage: boolean = true;
  protected placeholderImage: string = '';

  protected readonly env = environment;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    if (this.Article && this.Article?.ImageReference) {
      this.imageUrl = `${environment.SiteUrls.AzureStorageBaseURL}${environment.ContainerNames.ArticleImages}/${this.Article.Id}/${this.Article.ImageReference}`;
    } else {
      this.imageUrl = `${environment.SiteUrls.AzureStorageBaseURL}/branding/HRN_header_idmanual.jpg`;
    }
    this.placeholderImage = `${this.env.SiteUrls.AzureStorageBaseURL}${environment.SiteUrls.NewsImagePlaceHolderUrl}`;
  }

  viewArticle() {
    if (this.Article) {
      this.router.navigate([`insights/article/${this.Article.Id}`])
        .then(() => {
        });
    }
  }

  getImageUrl() {
    if (this.hasImage) {
      return `url('${this.imageUrl}')`;
    } else {
      return `url('${this.placeholderImage}')`;
    }
  }
}
